import React, { PureComponent, Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

export default class VerbText extends PureComponent {
    static propTypes = {
        messageId: PropTypes.string,
        defaultMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
        description: PropTypes.string,
        valuesToInject: PropTypes.object,
        formatIntl: PropTypes.bool,
        customMessage: PropTypes.string
    };

    _formatMessage = (messageId, defaultMessage, description, valuesToInject) => (
        <FormattedMessage
            id={messageId}
            defaultMessage={defaultMessage}
            description={description}
            values={valuesToInject}
        />
    );

    render() {
        const {
            messageId = '',
            defaultMessage = '',
            valuesToInject = {},
            description = '',
            formatIntl = true,
            customMessage = ''
        } = this.props;
        const messageToRender = formatIntl
            ? this._formatMessage(messageId, defaultMessage, description, valuesToInject)
            : customMessage;

        return <Fragment>{messageToRender}</Fragment>;
    }
}
